export { AcmeTicker } from './AcmeTicker.js';
export { DEFAULTS } from './types.js';
export type {
  AcmeTickerControls,
  AcmeTickerOptions,
  ControlTarget,
  RtlSetting,
  TickerDirection,
  TickerHost,
  TickerType,
} from './types.js';
